import React, {Component} from 'react';
import {connect} from 'react-redux';
import Notifications from "../components/notifications";
import {
	changeNotificationsField,
	clearNotificationsFilters, getNotificationTypes,
	notificationsCaseTypeFilterChanged,
	notificationsStatusFilterChanged,
	pageShift,
	requestGetAllNotifications, requestPatchNotification,
	selectActiveTabNotification
} from "../actions/notifications";
import { push } from 'connected-react-router'
import {requestGetSelectedApplication} from "../actions/newApplication";
import {requestGetApplicationStatuses} from "../actions/applicationStatuses";
import {receiveApplicationNotification} from "../actions/applicationPolicy";
import {getCaseTypes} from "../actions/caseTypes";
import {isAragUser, isSolicitorUser} from "../helpers/functions";
import {getSolicitorGroupCaseTypes} from "../actions/groups";
import {requestGetUpdateQuestions} from "../actions/updateTab";

const getRequestParams = (props) => {
	const calcOffset = props.notifications.selectedView*(props.notifications.page -1);
	return {
		limit: props.notifications.selectedView,
		offset: calcOffset>0? calcOffset:0,
		shallow: true,
		selectedUpdateFormQuestions: props.notifications.selectedUpdateFormQuestions,
        selectedNotificationTypes: props.notifications.selectedNotificationTypes,
		selectedCaseTypes: props.notifications.selectedCaseTypes,
		selectedStatuses: props.notifications.selectedStatuses
	}
};

class NotificationsHOC extends Component {
	componentWillMount() {
		let parameters = getRequestParams(this.props);
		this.props.getAllNotifications(parameters);
		this.props.requestGetApplicationStatuses();
		if(isAragUser(this.props.user.loggedInUser.roles)){
			this.props.requestGetCaseTypes();
			this.props.getUpdateQuestions();
			this.props.getNotificationTypes();
		}

		if(isSolicitorUser(this.props.user.loggedInUser.roles) && this.props.user.loggedInUser.solicitorGroupId){
            this.props.getSolicitorGroupCaseTypes(this.props.user.loggedInUser.solicitorGroupId);
        }
	}

	componentWillReceiveProps(nextProps) {
		if(
			this.props.notifications.selectedView !== nextProps.notifications.selectedView
			|| this.props.notifications.page !== nextProps.notifications.page
            || (
                this.props.notifications.wasFilterButtonPressed
                && !nextProps.notifications.wasFilterButtonPressed
            )
		) {
			let parameters = getRequestParams(nextProps);
			this.props.getAllNotifications(parameters);
		}
	}

	_getNotificationStatusText = (notification) => {
		if(!notification.applicationStatusName.includes('Referred')){
			return notification.applicationStatusName;
		}
		else{
			if(isAragUser(this.props.user.loggedInUser.roles)){
				return notification.applicationStatusName + ' to ' + notification.referredTo
			}
			else {
				return notification.applicationStatusName
			}
		}
	};

	_getCaseTypesOptions = () => {
		if(isAragUser(this.props.user.loggedInUser.roles)){
			return this.props.caseTypes.cases;
		}
		if(isSolicitorUser(this.props.user.loggedInUser.roles)){
			return this.props.solicitorCaseTypes;
		}
		return [];
	};

	selectUpdateFormQuestions = (questions) => {
		this.props.changeNotificationsField('selectedUpdateFormQuestions', questions)
	};

	selectNotificationsType = (evt) => {
        this.props.changeNotificationsField(evt.target.name, evt.target.value)
    };

	selectApplicationStatus = (statuses) => {
	    //if the selected status of the policy is draft, closed, filter by update form questions is redundant and must
        //not be displayed and the selected questions must be cleared
        if(statuses.find(item => item.value === 'Draft') && statuses.length === 1){
            this.props.changeNotificationsField('selectedUpdateFormQuestions', []);
        }

	    this.props.changeNotificationsField('selectedStatuses', statuses);
    };

	selectCaseTypes = (caseTypes) => {
	    this.props.changeNotificationsField('selectedCaseTypes', caseTypes)
    };

	handleFilterClick = () => {
		this.props.changeNotificationsField('wasFilterButtonPressed', true);
		const parameters = getRequestParams(this.props);
		this.props.getAllNotifications(parameters);
	};

	shouldDisplayUpdateFormQuestionsFilter = () => {
        return (
			(
				(
					this.props.notifications.selectedStatuses.find(item => item.value === 'Draft')
					&& this.props.notifications.selectedStatuses.length !== 1
				)
				|| (
					!this.props.notifications.selectedStatuses.find(item => item.value === 'Draft')
				)
			)
            && this.props.notifications.selectedNotificationTypes.find(item => item.value === 'Updated')
        )
    };

	selectNotificationTypes = (notificationTypes) => {
	    //if new selected notification types does not include type: "Updated" then the user must not filter by
        //update form questions
        if(
            this.props.notifications.selectedNotificationTypes.find(item => item.value === 'Updated')
            && !notificationTypes.find(item => item.machineName === 'Updated')
        ){
            this.props.changeNotificationsField('selectedUpdateFormQuestions', []);
        }

	    this.props.changeNotificationsField('selectedNotificationTypes', notificationTypes)
    };

	render(){
		return(
			<Notifications
				requestPatchNotification={this.props.requestPatchNotification}
                fetchingApplicationStatuses={this.props.fetchingApplicationStatuses}
                fetchingCaseTypes={this.props.fetchingCaseTypes}
                fetchingUpdateFormQuestions={this.props.fetchingUpdateFormQuestions}
                selectNotificationTypes={this.selectNotificationTypes}
                shouldDisplayUpdateFormQuestionsFilter={this.shouldDisplayUpdateFormQuestionsFilter}
                clearNotificationsFilters={this.props.clearNotificationsFilters}
				handleFilterClick={this.handleFilterClick}
                selectCaseTypes={this.selectCaseTypes}
                selectApplicationStatus={this.selectApplicationStatus}
                selectNotificationsType={this.selectNotificationsType}
                selectUpdateFormQuestions={this.selectUpdateFormQuestions}
				userRoles={this.props.user.loggedInUser.roles}
				updateFormQuestions={this.props.updateFormQuestions}
                _getNotificationStatusText={this._getNotificationStatusText}
				Store={this.props.notifications}
				PageShift={this.props.pageShift}
				getSelectedApplication = {this.props.getSelectedApplication}
				selectActiveTabNotification = {this.props.selectActiveTabNotification}
				HandleInputChange={this.props.changeNotificationsField}
				caseTypes = {this._getCaseTypesOptions()}
				applicationStatuses = {this.props.applicationStatuses}
				onSelectedStatusChange = {this.props.notificationsStatusFilterChanged}
				onSelectedCaseTypeChange = {this.props.notificationsCaseTypeFilterChanged}
				receiveApplicationNotification = {this.props.receiveApplicationNotification}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		notifications: state.notifications,
		user: state.user,
		caseTypes: state.caseTypes,
		applicationStatuses: state.applicationStatuses,
		solicitorCaseTypes: state.newApplication.caseTypes,
		updateFormQuestions: state.updateTab.questions,
        fetchingUpdateFormQuestions: state.updateTab.fetching,
        fetchingCaseTypes: state.caseTypes.fetching,
        fetchingApplicationStatuses: state.applicationStatuses.fetching
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAllNotifications: (payload) => {
			dispatch(requestGetAllNotifications(payload))
		},
		getSelectedApplication: (id) => {
			dispatch(requestGetSelectedApplication(id))
		},
		changeNotificationsField: (key, value) => {
			dispatch(changeNotificationsField(key, value))
		},
		pageShift: (direction, totalPaginationBoxes) => {
			dispatch(pageShift(direction, totalPaginationBoxes))
		},
		selectActiveTabNotification: (tab, key, notificationEventName) => {
			dispatch(selectActiveTabNotification(tab, key, notificationEventName))
		},
		push: (path) => {
			dispatch(push(path))
		},
		notificationsCaseTypeFilterChanged: (payload) => {
			dispatch(notificationsCaseTypeFilterChanged(payload))
		},
		notificationsStatusFilterChanged: (payload) => {
			dispatch(notificationsStatusFilterChanged(payload))
		},
		requestGetApplicationStatuses: () => {
			dispatch(requestGetApplicationStatuses())
		},
        requestGetCaseTypes: () => {
            dispatch(getCaseTypes())
        },
		receiveApplicationNotification: (payload) => {
			dispatch(receiveApplicationNotification(payload))
		},
        getSolicitorGroupCaseTypes: (groupId) => {
            dispatch(getSolicitorGroupCaseTypes(groupId))
        },
		getUpdateQuestions: (id) => {
			dispatch(requestGetUpdateQuestions(id))
		},
        clearNotificationsFilters: (payload) => {
		    dispatch(clearNotificationsFilters(payload))
        },
        getNotificationTypes: (payload) => {
		    dispatch(getNotificationTypes(payload))
        },
		requestPatchNotification: (notificationId, viewed, applicationId) => {
			dispatch(requestPatchNotification(notificationId, viewed, applicationId));
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsHOC);